import { MutationCache, QueryCache, QueryClient } from "@tanstack/react-query";

type QueryError = Error & { status?: number }

export const queryClient = new QueryClient({
    queryCache: new QueryCache({
        onError: (error, query) => console.error('Query Error:', { error, queryKey: query.queryKey }),
    }),
    mutationCache: new MutationCache({
        onError: (error) => console.error('Mutation Error:', error),
    }),
    defaultOptions: {
        queries: {
            staleTime: 5 * 60 * 1000,
            gcTime: 10 * 60 * 1000,
            retry: (failureCount, error: QueryError) => {
                const status = error?.status ?? 0;
                if (status === 0) return false;
                if (status >= 400 && status < 500) return false;

                return failureCount < 2;
            },
            refetchOnWindowFocus: true,
            refetchOnReconnect: true,
        },
        mutations: {
            retry: false,
        },
    }
})